const { trackGtm4 } = require('util/functions');

module.exports = {
	init() {
		const link = this.root.querySelector('.ir-share-price-overview--cta');
		const title = this.root.querySelector('.ir-share-price-overview--title');

		link.addEventListener('click', () => {
			trackGtm4({
				event: 'GA4_event_c_cta',
				widget_name: 'V3-Investor Share Price',
				widget_title: title.innerHTML,
				link_text: link.innerText,
				link_url: link.href,
				button_type: '',
			});
		});
	},
};
